import { Modal, ModalFuncProps, Typography } from "antd";
import color from "../../../theme/color";

/**
 * 확인창
 * @style ant.custom.css
 * @param title
 * @param onOk
 */
export const openConfirm = ({
  title,
  danger,
  ...props
}: ModalFuncProps & { danger?: boolean }) => {
  Modal.confirm({
    title: (
      <Typography.Text
        style={{ fontSize: 19, fontWeight: 700, color: color.gray2 }}
      >
        {title}
      </Typography.Text>
    ),
    className: "ant-confirm-modal",
    centered: true,
    icon: false,
    bodyStyle: { padding: 24, display: "block" },
    okButtonProps: {
      size: "large",
      style: { width: "calc(50% - 4px)" },
      danger,
    },
    cancelButtonProps: {
      size: "large",
      style: { width: "calc(50% - 4px)" },
      type: "default",
    },
    ...props,
  });
};
